import { AddressZero } from "@ethersproject/constants";
import { createChecksumAddressProtocolInstanceValueOrThrow } from "@silo/types";

export {
  MainnetLegacyMarketAddress,
  MainnetLlamaMarketAddress,
  MainnetGrandMarketAddress,
  ArbitrumMarketAddress,
  LocalMarketAddress,
  AnvilMarketAddress,
  OptimismMarketAddress,
  BaseMarketAddress,
  LrtbaseMarketAddress,
} from "./market-addresses";
export {
  MainnetTokenAddress,
  ArbitrumTokenAddress,
  OptimismTokenAddress,
  BaseTokenAddress,
  TOKEN_ADDRESS,
} from "./token-addresses";
export type { TokenAddressChainValue } from "./token-addresses";
export * from "./contract-addresses";

export const LPPriceProviderAddress =
  createChecksumAddressProtocolInstanceValueOrThrow({
    mainnetLegacy: "0xb664Ca87Df549D110C59a96b10278439617D0813",
    // TODO (mainnet-llama): update this address
    mainnetLlama: AddressZero,
    mainnetGrand: AddressZero,
    arbitrum: AddressZero,
    optimism: AddressZero,
    base: AddressZero,
    lrtbase: AddressZero,
    local: AddressZero,
    anvil: "0x3205da92193A85413fEC3F3a005190FbDDda2FFE",
  });

export const DiaPriceProviderAddressA =
  createChecksumAddressProtocolInstanceValueOrThrow({
    mainnetLegacy: "0x0000000000000000000000000000000000000000",
    mainnetLlama: "0x0000000000000000000000000000000000000000",
    mainnetGrand: "0x0000000000000000000000000000000000000000",
    arbitrum: "0x076Bb60d16e6E0D0C98BFE08A08EeeEFaC89B3C9",
    optimism: "0x0000000000000000000000000000000000000000",
    base: "0x0000000000000000000000000000000000000000",
    lrtbase: "0x0000000000000000000000000000000000000000",
    local: "0x0000000000000000000000000000000000000000",
    anvil: "0x0000000000000000000000000000000000000000",
  });

export const DiaPriceProviderAddressB =
  createChecksumAddressProtocolInstanceValueOrThrow({
    mainnetLegacy: "0x0000000000000000000000000000000000000000",
    mainnetLlama: "0x0000000000000000000000000000000000000000",
    mainnetGrand: "0x0000000000000000000000000000000000000000",
    arbitrum: "0x2B6Bbb13B0415ad06F8685A112C00382672a3DD9",
    optimism: "0x0000000000000000000000000000000000000000",
    base: "0x0000000000000000000000000000000000000000",
    lrtbase: "0x0000000000000000000000000000000000000000",
    local: "0x0000000000000000000000000000000000000000",
    anvil: "0x0000000000000000000000000000000000000000",
  });

export const UniswapV3PriceProviderV3Address =
  createChecksumAddressProtocolInstanceValueOrThrow({
    mainnetLegacy: "0x0000000000000000000000000000000000000000",
    mainnetLlama: "0x268Fc6C5Eb17BE53a8670895be62B414c3E636Ce",
    mainnetGrand: "0x0000000000000000000000000000000000000000",
    arbitrum: "0x0000000000000000000000000000000000000000",
    optimism: "0x0000000000000000000000000000000000000000",
    base: "0x0000000000000000000000000000000000000000",
    lrtbase: "0x0000000000000000000000000000000000000000",
    local: "0x0000000000000000000000000000000000000000",
    anvil: "0x0000000000000000000000000000000000000000",
  });

export const WSTETHPriceProviderAddress =
  createChecksumAddressProtocolInstanceValueOrThrow({
    mainnetLegacy: "0xE56955B54Ae444d73A52aD3179941E1700910d35",
    mainnetLlama: "0x0000000000000000000000000000000000000000",
    mainnetGrand: "0x0000000000000000000000000000000000000000",
    arbitrum: "0xf1268Fd0F285fCDcA2bC130E1B44229079487DD1",
    optimism: "0x9DEaA1Af59932c0D71DE6C04e50581f4605bE416",
    base: "0x0000000000000000000000000000000000000000",
    lrtbase: "0x0000000000000000000000000000000000000000",
    local: "0xAe91E8B8653d87135a095503A2aB1E2506F4Fab6",
    anvil: "0xE56955B54Ae444d73A52aD3179941E1700910d35",
  });
